import {
  PersonAvatar,
  TeamIcon,
} from '@/shared/components/people-team-list/PeopleTeamAvatars';

function getInitials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);
  return `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}`.toUpperCase();
}

export function TagPill({
  name,
  imageUrl,
}: {
  name: string;
  imageUrl?: string;
}) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded bg-[#f0f1f3] py-0.5 pe-2 ps-1.5 text-[12.5px] font-medium text-foreground leading-none">
      <PersonAvatar
        initials={getInitials(name)}
        imageUrl={imageUrl}
        size="sm"
      />
      {name}
    </span>
  );
}

export function TeamPill({ name }: { name: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded bg-[#f0f1f3] py-0.5 pe-2 ps-1.5 text-[12.5px] font-medium text-foreground leading-none">
      <TeamIcon size="sm" />
      {name}
    </span>
  );
}
